<template>
  <div class="avatar-teacher" :class="['mode-' + mode]">
    <nuxt-img
      v-if="img && (img.source || img.jpg_248X186)"
      class="max-w-full"
      :src="imgSource(img)"
      :alt="name"
      :sizes="sizes"
      width="200"
      height="150"
      loading="lazy"
      format="webp"
      placeholder
    />
  </div>
</template>

<script>
export default {
  name: 'BaseAvatarTeacher',
  props: {
    img: {
      type: Object,
      default: () => {}
    },
    name: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      default: 'slider',
      valid: ['slider', 'list', 'profile', 'small']
    }
  },
  computed: {
    sizes () {
      const obj = {
        slider: '200px md:210px lg:240px',
        list: '110px lg:200px',
        profile: '',
        small: '116px'
      }
      return obj[this.mode]
    }
  },
  methods: {
    imgSource (img) {
      return img?.source?.jpg_248X186?.url || img?.jpg_248X186?.url
    }
  }
}
</script>

<style scoped lang="scss">
.avatar-teacher {
  @apply rounded-2xl inline-flex items-center justify-center p-[3px];
  &.mode-slider {
    @apply w-[208px] h-[140px] lg:w-[248px] lg:h-[186px];
    img {
      @apply w-[200px] md:w-[210px] lg:w-[240px];
    }
  }
  &.mode-list {
    @apply w-[116px] h-[88px] lg:w-[208px] lg:h-[158px];
    img {
      @apply w-[110px] h-[82px] lg:w-[200px] lg:h-[150px];
    }
  }
  &.mode-small {
    @apply w-[116px] h-[88px];
    img {
      @apply w-[110px] h-[82px];
    }
  }
  background: linear-gradient(242.69deg, #6DC1DC 16.13%, #A690FC 30.79%, #FC96BB 56.79%, #FFC397 84.3%);
  img {
    @apply rounded-2xl;
  }
  &__placeholder {
    @apply rounded-2xl m-[3px] bg-white flex items-center justify-center w-full h-full;
  }
}
</style>
